module.exports = __webpack_public_path__ + "static/media/portfolio_carboncamera.b7924c18.png";